module.exports = __webpack_public_path__ + "static/media/sumeet-profile.978aecf8.png";